import GroupView from "@/components/GroupView";
import Chainage from "@/pages/saas/Chainage";
import UtilityMapping from "@/pages/saas/UtilityMapping";
import Ontologie from "@/pages/saas/Ontologie";
import Cartographie360Index from "@/pages/saas/Cartographie360Index";
import GraphNoeudsPage from "@/pages/saas/GraphNoeudsPage";

export default function Cartographies() {
  return (
    <GroupView
      groupKey="cartographies"
      groupLabel="Cartographies"
      overline="Module groupe · Vues x-ray"
      tabs={[
        { slug: "index", label: "Cartographie 360°", Component: Cartographie360Index },
        { slug: "chainage", label: "Chaînage causal", Component: Chainage },
        { slug: "dependances", label: "Cartographie des dépendances", Component: UtilityMapping },
        { slug: "graphe", label: "Graphe multi-niveaux", Component: GraphNoeudsPage },
        { slug: "ontologie", label: "Ontologie", Component: Ontologie },
      ]}
    />
  );
}
